import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-325df150"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "text-center mb-0"
};
const _hoisted_2 = { ref: "chartCanvas" };
const _hoisted_3 = /*#__PURE__*/ _createTextVNode(" Download as ");
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(", ");
const _hoisted_5 = /*#__PURE__*/ _createTextVNode(", ");
const _hoisted_6 = /*#__PURE__*/ _createTextVNode(", or ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", null, [
        (_ctx.title !== '')
            ? (_openBlock(), _createElementBlock("h6", _hoisted_1, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
        _createElementVNode("div", {
            class: _normalizeClass('ratio ' + _ctx.ratio)
        }, [
            _createElementVNode("canvas", _hoisted_2, null, 512)
        ], 2),
        _createElementVNode("small", null, [
            _hoisted_3,
            _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.download('png')), ["prevent"])),
                href: "#"
            }, "PNG"),
            _hoisted_4,
            _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.download('csv')), ["prevent"])),
                href: "#"
            }, "CSV"),
            _hoisted_5,
            _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.download('xlsx')), ["prevent"])),
                href: "#"
            }, "XLSX"),
            _hoisted_6,
            _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.download('json')), ["prevent"])),
                href: "#"
            }, "JSON")
        ])
    ]));
}
